const data = {
  header: ["", ""],
  values: [
    ["Academic Working Days", "8:00 a.m. To 8.00 p.m."],
    ["Academic Weekend", "08.00a.m To. 6.00 P.m."],
    ["Transaction Hours (Counter Timings) Issuing of Books", "9.00 a.m. To 6.00 p.m."],
    ["Vacation & Holidays", "9.00 a.m. To 4.00 p.m."]
  ]
}


export { data };